import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MessageService } from '../../../services/message.service';
import { MasterService } from '../../../services/master.service';
import { StoreService } from '../../../services/store.service';
import * as words from '../../../services/language'

import { Recent } from 'src/app/models/recent.model';
import { daysAgo } from 'src/app/utils/date';
import { recentIcon } from 'src/app/utils/icons';

@Component({
    selector: 'recents',
    templateUrl: './recents.component.html',
    styleUrls: ['./recents.component.scss'],
    standalone: false
})
export class RecentsComponent implements OnInit, OnChanges {
    
    // Currently selected language
    @Input() language: string = localStorage.getItem('language') ? localStorage.getItem('language') : 'EN'
    
    // Word replacements for each language.
    @Input() words: Object = words.language

    // A list of user recently accessed items.
    protected recents: Array<Recent> = []
    
    // Indicates whether the data is currently loading.
    protected loading: boolean = false

    constructor(private master: MasterService, private ms: MessageService, private store: StoreService) { }

    ngOnInit() {
        this.reset()
        this.fetch()
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!changes) {
            return
        }

        const first = Object.values(changes).some(c => c.isFirstChange())
        if (first) {
            return
        }
        

    }

    /*
    * Reset the recents array
    */
    private reset = (): void => {
        this.recents = null
    }

    /**
     * 
     */
    private fetch() {
        if (this.loading) {
            return
        }

        this.recents = null
        this.recents = []

        this.loading = true
        this.master.get(`recents?pi=1&ipp=9`, (res) => {
            this.loading = false
            if (!res || !res.data) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] });
                return
            }
  
            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error });
                return
            }

            this.recents = res.data.recents
        })
    }

    /**
     * 
     * @param accessed 
     * @returns 
     */
    protected when = (accessed: string) => {
        const days = Math.abs(daysAgo(accessed))

        if (days === 0) {
            return 'today'
        }

        if (days === 1) {
            'yesterday'
        }

        return `${days}d`
    }

    /**
     * 
     * @param resource 
     * @returns 
     */
    protected icon = (resource: string) => {
        return recentIcon(resource)
    }
}
